import 'nodelist-foreach-polyfill';
import $ from "jquery";
import slick from "slick-carousel";
import {initContact} from './pages/contact';
import {Home} from "./pages/home";
import Slideshow from "./components/Slider"
import {contactLabel} from "./utils/contact-label";
import animation from 'scrollmagic/scrollmagic/minified/plugins/animation.gsap.min'
import indcator from 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min'
import ScrollMagic from 'scrollmagic'

import {backToTop} from "./utils/backToTop"


import {TimelineMax, TweenMax} from "gsap";

require('intersection-observer');
import swal from 'sweetalert';

$('#hamburger').click((e) => {
    e.preventDefault();
    if (window.innerWidth <= 992) {
        $("#hamburger").toggleClass("active");
        $("#menu-menu-principal").toggleClass("active");
    }

});

$('main, footer').click((e) => {
    if ($('#menu-menu-principal').hasClass("active")) {
        e.preventDefault();
        $("#hamburger").toggleClass("active");
        $("#menu-menu-principal").toggleClass("active");
    }

});

$('#menu-menu-principal > .collapse').click(function (e) {
    if (window.innerWidth <= 992) {
        if(e.target.tagName === "LI") {
            if ($('#menu-menu-principal').hasClass("active")) {
                if ($("#menu-menu-principal li").hasClass("show")) {

                    if ($(this).hasClass("show")) {
                        $(this).toggleClass("show");
                    } else {
                        $("#menu-menu-principal li.show").toggleClass("show");
                        $(this).toggleClass("show");
                    }


                } else {
                    $(this).toggleClass("show");

                }

            }
        }
    }

}).children().click(function (e) {
    // e.stopPropagation();
});


class Main {

    constructor(opt = {}) {
        window.scrollTo(0, 0);


        let scooll = new backToTop()


        console.log("%cCreated by Paprika, with ❤", "color: #ff3e50; padding: 5px 0px 1px; border-bottom:2px solid #ff3e50;");

        /**
         * Initialisation des hubs, les partenaires dans le footer et ils nous font confiances // Initialisation du formulaire "vous avez-un projet"
         */
        this.sliderHub();
        contactLabel();
        this.initContact();


        /**
         * Initialisation des gallery dans la partie articles
         */
        if (document.querySelector(".single-news") || document.querySelector(".page-contenu .gallery-acf")) {
            this.initGalleryNews();
        }

        /**
         * Initialisation du slider dans la page single Références
         */
        if (document.querySelector(".single-references")) {
            this.initSliderReference();
        }

        /**
         * Initialisation du slider dans la page single Références
         */
        if (document.querySelector(".bg-hommes")) {
            this.initIntersectionLesHommes()
        }

        if (document.querySelector(".container-ref")) {
            this.initIntersectionReferences()
        }


        /**
         * Initialisation des animations sur la page home
         */
        if (document.querySelector(".copeau-general-flou")) {
            // Pour enlever les start 2 et trigger il faut juste commenter la ligne addIndicators

            this.tooSmall = false;
            this.controller = null;
            this.maxWidth = 992; // or whatever your max width is

            if ($(window).width() < this.maxWidth) {
                this.tooSmall = true;
            }

            if (!this.tooSmall) {
                this.initCopeau();
            }

            $(window).resize(() => {

                let wWidth = $(window).width();

                if (wWidth < this.maxWidth) {
                    if (this.controller !== null && this.controller !== undefined) {

                        this.controller = this.controller.destroy(true);

                        TweenMax.set(".copeau-general-flou", {clearProps: "all"});
                        TweenMax.set(".copeau-general-shadow", {clearProps: "all"});
                        TweenMax.set(".copeau-general-petit", {clearProps: "all"});
                    }
                } else if (wWidth >= this.maxWidth) {
                    if (this.controller === null || this.controller === undefined) {
                        // reinitialize ScrollMagic only if it is not already initialized
                        this.initCopeau()
                    }
                }
            });

        }


        /**
         * Initialisation des copeaux
         */
        if (document.querySelector(".page-home")) {
            // Pour enlever les start 2 et trigger il faut juste commenter la ligne addIndicators

            this.tooSmall = false;
            this.controller = null;
            this.maxWidth = 992; // or whatever your max width is

            if ($(window).width() < this.maxWidth) {
                this.tooSmall = true;
            }

            if (!this.tooSmall) {
                this.initAnimationPageHome();
            }

            $(window).resize(() => {

                let wWidth = $(window).width();

                if (wWidth < this.maxWidth) {
                    if (this.controller !== null && this.controller !== undefined) {
                        // completely destroy the controller


                        console.log("MLKMLK");

                        this.controller = this.controller.destroy(true);
                        TweenMax.set(".copeau-1", {clearProps: "all"});
                        TweenMax.set(".copeau-1-shadow", {clearProps: "all"});
                        TweenMax.set(".petit-copeau-1", {clearProps: "all"});

                        TweenMax.set(".copeau-2", {clearProps: "all"});
                        TweenMax.set(".copeau-2-shadow", {clearProps: "all"});
                        TweenMax.set(".petit-copeau-2", {clearProps: "all"});
                        TweenMax.set(".montagne-left", {clearProps: "all"});
                        // if needed, use jQuery to manually remove styles added to DOM elements by GSAP etc. here
                    }
                } else if (wWidth >= this.maxWidth) {
                    if (this.controller === null || this.controller === undefined) {
                        // reinitialize ScrollMagic only if it is not already initialized
                        this.initAnimationPageHome()
                    }
                }
            });


            this.initSlider();
            // Création du slider les savoir-faires
            this.slide = new Slideshow(document.querySelector('.slide-savoir'));

            // Permet de rajouter les classes dans la partie les références
            this.initIntersection()
            this.initIntersectionLine()
            this.initIntersectionTransform()

        }

    }


    addEvent() {

    }

    intro() {

    }

    initContact() {
        var theForm = document.getElementById('theForm');

        new stepsForm(theForm, {
            onSubmit: function (form) {
                // hide form
                classie.addClass(theForm.querySelector('.simform-inner'), 'hide');

                var messageEl = theForm.querySelector('.final-message');

                var $form = $(".questions");
                var $inputs = $form.find("input, textarea");
                var serializedData = $inputs.serialize();
                $.post(
                    ajaxurl,
                    {
                        'action': 'mon_action',
                        'param': serializedData
                    },
                    function (data) {

                        if (data.status === 202) {
                            var arrayMessage = data.message;
                            if (arrayMessage.length < 2) {
                                swal("Erreur dans le remplissage", data.message[0], "warning");
                            } else {
                                var stringArray = arrayMessage[0] + "\n";
                                for (var i = 1; arrayMessage.length > i; i++) {
                                    stringArray += arrayMessage[i] + "\n";
                                }
                                swal("Erreur dans le remplissage", stringArray, "warning");
                                messageEl.innerHTML = "Erreur dans le remplissage";


                            }
                        } else {
                            swal("Email envoyé", "Nous vous recontacterons", "success");
                            messageEl.innerHTML = "L'email est envoyé !";
                        }

                    },
                    "json"
                );

                // let's just simulate something...
                classie.addClass(messageEl, 'show');
            }
        });
    }


    initSlider() {


        if ($('.slider-service')) {
            $('.slider-service').slick({
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,

                dots: true,
                appendDots: $(".slick-dots-services"),
                prevArrow: $('section.home__services .controls .prev'),
                nextArrow: $('section.home__services .controls .next'),
                responsive: [
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }

                    }, {

                        breakpoint: 580,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }

                    }]
            });
        }

        if ($('.slide-ref-mobile')) {
            $('.slide-ref-mobile').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '100px',
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            centerPadding: '80px',
                        }

                    },
                    {
                        breakpoint: 570,
                        settings: {
                            centerPadding: '40px',
                        }

                    },
                    {
                        breakpoint: 455,
                        settings: {
                            centerPadding: '30px',
                        }

                    },
                ]

                //prevArrow: $('section.home__services .controls .prev'),
                // nextArrow: $('section.home__services .controls .next')
            });
        }
        if ($('.slide-savoir-mobile')) {
            $('.slide-savoir-mobile .slider-items-mobile').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: true,
                centerPadding: '120px',
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            centerPadding: '80px',
                        }

                    },
                    {
                        breakpoint: 540,
                        settings: {
                            centerPadding: '40px',
                        }

                    },
                    {
                        breakpoint: 455,
                        settings: {
                            centerPadding: '30px',
                        }

                    },
                ]
                //prevArrow: $('section.home__services .controls .prev'),
                // nextArrow: $('section.home__services .controls .next')
            });
        }


    }

    initIntersection() {
        var cible = document.querySelectorAll('.js-observer');

        var options = {
            threshold: 0.2 /* 50% */
        };

        var observer = new IntersectionObserver(
            onIntersection,
            options
        );

        cible.forEach(observe => {
            observer.observe(observe);
        })

        function onIntersection(entries) {
            var target;
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.2) {
                    entry.target.querySelector(".ref").classList.add('is-visible');
                    // observer.unobserve(cible);
                }
            })

        }

    }

    initIntersectionLine() {
        var cible = document.querySelectorAll('.js-observer-line');

        var options = {
            threshold: 0.4 /* 50% */
        };

        var observer2 = new IntersectionObserver(
            onIntersection,
            options
        );

        cible.forEach(observe => {
            observer2.observe(observe);
        })

        function onIntersection(entries) {
            var target;
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.4) {
                    entry.target.classList.add('is-visible');
                    // observer.unobserve(cible);
                }
            })

        }

    }

    initIntersectionTransform() {
        var cible = document.querySelectorAll('.js-observer-transform');

        var options = {
            threshold: 0.6 /* 50% */
        };

        var observer3 = new IntersectionObserver(
            onIntersection,
            options
        );

        cible.forEach(observe => {
            observer3.observe(observe);
        })

        function onIntersection(entries) {
            var target;
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.6) {
                    entry.target.classList.add('is-visible');
                    // observer.unobserve(cible);
                }
            })

        }

    }


    initAnimationPageHome() {

        this.controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: "onLeave"
            }
        });

        const body = document.body;
        const main = document.querySelector('.montagne-left');

        let sx = 0;
        let sy = 0;

        let dx = sx;
        let dy = sy;

        // body.style.height = main.clientHeight + 'px';


        window.addEventListener('scroll', scroll);

        function scroll() {

            sx = window.pageXOffset;
            sy = window.pageYOffset;

        }

        window.requestAnimationFrame(render);

        function render() {
            dx = lerp(dx, sx, 0.07);
            dy = lerp(dy, sy, 0.07);

            dx = Math.floor(dx * 100) / 100;
            dy = Math.floor(dy * 100) / 100;

            if(window.scrollY < document.querySelector(".home__savoir-faire").offsetTop) {
                main.style.transform = `translate(-${dx}px, ${-dy * 0.2}px)`;
            }

            window.requestAnimationFrame(render);
        }

        function lerp(a, b, n) {
            return (1 - n) * a + n * b;
        }

        var tweenCopeau = new TimelineMax()
            .add([
                TweenMax.fromTo(".copeau-1", 1, {scale: 1, bottom: 0}, {bottom: 400, ease: Quad.easeOut}),
                TweenMax.fromTo(".copeau-1-shadow", 1, {scale: 1, bottom: 0}, {bottom: 200, ease: Quad.easeOut}),
                TweenMax.fromTo(".petit-copeau-1", 1, {scale: 1, bottom: 0}, {bottom: 100, ease: Quad.easeOut}),
            ]);

        var parallaxSceneCopeau = new ScrollMagic.Scene({
            triggerElement: ".slider-items",
            duration: 3000,
            triggerHook: 0,
            tweenChanges: true,
        })
            .setTween(tweenCopeau)
            // .addIndicators()
            .addTo(this.controller);


        var tweenCopeau2 = new TimelineMax()
            .add([
                TweenMax.fromTo(".copeau-2", 1, {scale: 1, bottom: 0, rotation: 0}, {
                    rotation: 30,
                    bottom: 200,
                    ease: Quad.easeOut
                }),
                TweenMax.fromTo(".copeau-2-shadow", 1, {scale: 1, bottom: 0, rotation: 0}, {
                    rotation: 20,
                    bottom: 150,
                    ease: Quad.easeOut
                }),
                TweenMax.fromTo(".petit-copeau-2", 1, {scale: 1, bottom: 0}, {bottom: 100, ease: Quad.easeOut}),

            ]);

        var parallaxSceneCopeau2 = new ScrollMagic.Scene({
            triggerElement: ".home__services",
            duration: 1000,
            triggerHook: 0,
            tweenChanges: true,
        })
            .setTween(tweenCopeau2)
            // .addIndicators()
            .addTo(this.controller);


    }

    sliderHub() {
        if ($('.slide-confiance')) {
            $('.slide-confiance').slick({
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 2,
                dots: true,
                arrows: true,
                appendDots: $(".hub__confiance .slick-dots-services"),
                prevArrow: $('.hub__confiance .slide-controls .prev'),
                nextArrow: $('.hub__confiance .slide-controls .next'),
                centerMode: true,
                centerPadding: '10px',
                responsive: [
                    {
                        breakpoint: 1250,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,

                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 2,

                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,

                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });
        }
        if ($('.slide-partenaire')) {
            $('.slide-partenaire').slick({
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: $('.partenaire .controls .prev'),
                nextArrow: $('.partenaire .controls .next'),
                responsive: [
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 3,

                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 2,

                        }
                    },
                    {
                        breakpoint: 420,
                        settings: {
                            slidesToShow: 1,

                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

        }
    }

    initGalleryNews() {
        let sliderNews = document.querySelectorAll('.gallery');

        sliderNews.forEach(slider => {
            $(slider).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrow: true,
                dots: true,
                //prevArrow: $('section.home__services .controls .prev'),
                // nextArrow: $('section.home__services .controls .next')
            });
        })

    }

    initSliderReference() {
        if (document.querySelector('.slider-for')) {
            $('.slider-for').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                dots: false,
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToScroll: 1,
                slidesToShow: 6,
                asNavFor: '.slider-for',
                arrows: false,
                focusOnSelect: true,
                // dots: true,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 5,
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToScroll: 4,
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 406,
                        settings: {
                            slidesToScroll: 2,
                            slidesToShow: 2,
                        }
                    }
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ]
            });

        }
    }

    initCopeau() {

        var $triggerElement = $('<span class="trigger" style="visibility:hidden;"></span>');
        $("main").after($triggerElement);

        this.controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                triggerHook: "onCenter"
            }
        });


        var tweenCopeau = new TimelineMax()
            .add([
                TweenMax.fromTo(".copeau-general-flou", 1, {scale: 1, bottom: 200}, {bottom: 80, ease: Quad.easeOut}),
                TweenMax.fromTo(".copeau-general-shadow", 1, {scale: 1, bottom: 180}, {bottom: 40, ease: Quad.easeOut}),
                TweenMax.fromTo(".copeau-general-petit", 1, {scale: 1, bottom: 100}, {bottom: -60, ease: Quad.easeOut}),
            ]);

        this.parallaxSceneCopeamainu = new ScrollMagic.Scene({
            triggerElement: $triggerElement.get(0),
            duration: 750,
            offset: -750,
            triggerHook: 1,
            tweenChanges: true,
        })
            .setTween(tweenCopeau)
            // .addIndicators()
            .addTo(this.controller);

    }

    initIntersectionLesHommes() {

        var cible = document.querySelectorAll('.js-observer');

        var options = {
            threshold: 0.3 /* 50% */
        };

        var observer3 = new IntersectionObserver(
            onIntersection,
            options
        );

        cible.forEach(observe => {
            observer3.observe(observe);
        })

        function onIntersection(entries) {
            var target;
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.28) {
                    entry.target.classList.add('is-visible');
                    // observer.unobserve(cible);
                }
            })

        }

    }

    initIntersectionReferences() {
        var cible = document.querySelectorAll('.js-observer');

        var options = {
            threshold: 0.3 /* 50% */
        };

        var observer3 = new IntersectionObserver(
            onIntersection,
            options
        );

        cible.forEach(observe => {
            observer3.observe(observe);
        })

        function onIntersection(entries) {
            var target;
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0.28) {
                    entry.target.classList.add('is-visible');
                    // observer.unobserve(cible);
                }
            })

        }
    }
}

const app = new Main();
